import React from 'react';
import { DownloadIcon } from 'Icons';
import PropTypes from 'prop-types';
import ButtonIcon from 'components/IconButton';
import { useTranslation } from 'react-i18next';

const DownloadButton = ({
  onClick,
  className = '',
  title = 'Download',
  iconProps,
  theme = 'dark',
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <ButtonIcon
      title={t(title)}
      component={DownloadIcon}
      onClick={onClick}
      className={className}
      theme={theme}
      iconProps={{
        fontSize: 'inherit',

        ...iconProps,
      }}
      {...props}
    />
  );
};

DownloadButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
  theme: PropTypes.string,
  iconProps: PropTypes.object,
};

export default DownloadButton;
